$('.mobile-collection .text-with-icon button').click(function () {
  $('.mobile-collection .collection__facets').slideToggle(300);
  $('.mobile-collection .text-with-icon button').toggleClass('opened');
  if ($('.mobile-collection .text-with-icon button').hasClass('opened')) {
    $('.mobile-collection>.text-with-icon').css('borderBottom', 'none');
  } else {
    setTimeout(() => {
      $('.mobile-collection >.text-with-icon').css('border-bottom', '1px solid rgba(0, 0, 0, 0.1)');
    }, 300);
  }
});

$('.facets__floating-filter>button').click(function() {
  $("#facets-drawer").find('.accordion').removeAttr('open');
})

$(window).on('load', function () {
  var pbadge = $("#product_badge");
  var reveiwsElem = pbadge.parent().find('.overlay-goshop-right b');
  var reviewsCount = pbadge.find('.jdgm-prev-badge').attr('data-number-of-reviews');
  var isProductReviews = pbadge.attr('product_reviews_number_enable');

  if(isProductReviews == 'true') {
    reviewsCount = reviewsCount || '100k+';    
    pbadge.hide();
    reveiwsElem.text(reviewsCount);
  }
  
  window.dispatchEvent(new Event('resize'));
})


function syncRebuyGiftMessaging() {
  document.querySelectorAll('.rebuy-cart__progress-gift-variant-select-prompt').forEach(prompt => {
    if (prompt.textContent.trim() === 'Re-Add') {
      prompt.textContent = 'Select Gift';
    }
  });

  const rebuyStatusElement = document.querySelector('[rebuy-status]');
  const shouldLimitMultipleGifts = !rebuyStatusElement || rebuyStatusElement.getAttribute('rebuy-status') === 'false';
  const hasDiscountMessages = document.querySelectorAll('.rebuy-cart__flyout-item-discount-message').length > 0;

  document.querySelectorAll('.rebuy-cart__progress-gifts').forEach(el => {
    el.style.display = shouldLimitMultipleGifts && hasDiscountMessages ? 'none' : '';
  });
}

let rebuyGiftMessagingSyncQueued = false;

function queueRebuyGiftMessagingSync() {
  if (rebuyGiftMessagingSyncQueued) return;

  rebuyGiftMessagingSyncQueued = true;
  requestAnimationFrame(() => {
    rebuyGiftMessagingSyncQueued = false;
    syncRebuyGiftMessaging();
  });
}

for (const eventName of [
  'rebuy.loaded',
  'rebuy:cart.ready',
  'rebuy:cart.change',
  'rebuy:smartcart.ready',
  'rebuy:smartcart.show'
]) {
  document.addEventListener(eventName, queueRebuyGiftMessagingSync);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncRebuyGiftMessaging, { once: true });
} else {
  syncRebuyGiftMessaging();
}


window.addEventListener('load', function () {
  document.querySelectorAll('.shopify-section--main-collection .yotpo-bottomline-star-rating').forEach(function(el) {
    const link = el.querySelector('.yotpo-bottomline a');
    if (!link) return;

    const temp = link.innerHTML.replace('Reviews', '<span>Reviews</span>');
    link.innerHTML = temp;
    el.style.display = "block";
  })

  const starClickable = document.querySelector('product-rerender .star-clickable');
  if (starClickable) {
    starClickable.onclick = () => {
      document.querySelector('.shopify-section--apps').scrollIntoView({ behavior: 'smooth' });
    };
  }
});

